module.exports = __webpack_public_path__ + "img/phon9.60deebe4.png";